import { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Loader2, ZoomIn } from "lucide-react";
import { getCroppedImg } from "../lib/crop";

export function CropModal({ src, aspect = 4 / 3, onCancel, onDone, lang = "en" }) {
  const es = lang === "es";
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);
  const [busy, setBusy] = useState(false);

  const onComplete = useCallback((_, pixels) => setArea(pixels), []);

  const apply = async () => {
    if (!area) return;
    setBusy(true);
    const blob = await getCroppedImg(src, area);
    setBusy(false);
    onDone(blob);
  };

  return (
    <div className="fixed inset-0 z-[80] bg-black/70 grid place-items-center p-4" data-testid="crop-modal">
      <div className="bg-card rounded-xl w-full max-w-lg overflow-hidden border border-border shadow-2xl">
        <div className="px-4 py-3 border-b border-border font-serif text-lg">{es ? "Ajustar imagen" : "Adjust image"}</div>
        <div className="relative h-[320px] bg-black">
          <Cropper
            image={src} crop={crop} zoom={zoom} aspect={aspect}
            onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={onComplete}
            showGrid={true}
          />
        </div>
        <div className="p-4 space-y-3">
          <div className="flex items-center gap-3">
            <ZoomIn size={16} className="text-muted-foreground" />
            <input type="range" min="1" max="3" step="0.01" value={zoom} onChange={(e) => setZoom(+e.target.value)} className="w-full accent-primary" data-testid="crop-zoom" />
          </div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={onCancel} className="px-4 py-2 border border-border text-sm hover:border-primary" data-testid="crop-cancel">{es ? "Cancelar" : "Cancel"}</button>
            <button type="button" onClick={apply} disabled={busy} className="px-5 py-2 bg-primary text-primary-foreground text-sm flex items-center gap-2 disabled:opacity-50" data-testid="crop-apply">{busy && <Loader2 size={14} className="animate-spin" />} {es ? "Aplicar" : "Apply"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
